import * as React from "react";
import "./AedasLoading.css";
export function AedasLoading() {
  return (
    <div className="d-flex justify-content-center align-items-center w-100 h-100">
      <div className="lds-dual-ring"></div>
    </div>
  );
}
